// Module
var code = "<nlg-truck-allocation></nlg-truck-allocation>";
// Exports
module.exports = code;